import React from 'react'

export const LogoIcon = (props: { className: string, onClick: () => void }) => {
    const { className, onClick } = props
    return (
        <img
            onClick={onClick}
            className={`w-8 h-8 ${className}`}
            src={require('./logo192.png')}
            alt="IV Logo"
        />
    )
}
